import { sendPost } from "@/utils/request";

// 获取工会转换比例
function getBili(params) {
  const url = "/union/getunionconfig";
  return sendPost(url, params, true);
}
// 获取轮播图
function getImgs(params) {
  const url = "/goods/show/queryShowAdvertisingWheel";
  return sendPost(url, params);
}
// 获取推荐分类列表
function getKindsList(params) {
  const url = "/category/findCategoriesByCity";
  return sendPost(url, params);
}

// 获取首页演出列表
function getHomeShowlist(params) {
  const url = "/goods/show/firstPageShowList";
  return sendPost(url, params);
}

// 获取分类列表
function getWithChildren(params) {
  const url = "/goods/findCategoriesWithChildren";
  return sendPost(url, params);
}

// 获取列表页面列表
function getShowList(params) {
  const url = "/goods/show/findCategoryShowList";
  return sendPost(url, params);
}

// 获取详情
function getDetail(params) {
  const url = "/goods/show/queryMallShowByGoodsId";
  return sendPost(url, params);
}

// 下单
function buyNow(params) {
  const url = "/goods/show/queryShowBookingOrderPage";
  return sendPost(url, params);
}

// 缺票等级
function logTicket(params) {
  const url = "/trade/showOrder/userStockOutRecord";
  return sendPost(url, params);
}

// 获取主题色
function getCommonTheme(params) {
  const url = "/cms/front/skin/company/getCommonTheme";
  return sendPost(url, params, false, true);
}
export default {
  getImgs,
  getKindsList,
  getHomeShowlist,
  getWithChildren,
  getShowList,
  getDetail,
  buyNow,
  getBili,
  logTicket,
  getCommonTheme
};
